import { combineReducers } from 'redux';
import phoneNumber from './phoneNumber';
import uploadAvatar from './uploadAvatar';
import sendVerificationEmail from './sendVerificationEmail';
import currentStep from './currentStep';

export default combineReducers({
  phoneNumber,
  uploadAvatar,
  sendVerificationEmail,
  currentStep,
});
